import Router from "./Router.js";
export default function App() {
  return (
    <>
      <Router />
    </>
  );
}
